import toList from './ComponentUtil';
import UnorderedList from './UnorderedList';
import Icon from '../../images/Vector.png';
import './UnorderedList.scss'
import { useState } from 'react';
import { Close } from '@mui/icons-material';

function Samples({ data }) {
    const [fullmode, setFullmode] = useState([]);
    const [open, setOpen] = useState(false);
    return (
        <div className="sample-content-wrp">
            <div className='sample-text' onClick={() => {setOpen(!open)}}>{data.link}</div>
            {
                open && <div className='samples-wrp'>
                    <Close className='close-icon' onClick={() => {setOpen(!open)}} />
                    <div className='title'>{data.title}</div>
                    <div className='warnings'>
                        <UnorderedList title={""} compensation={data.warnings} />
                    </div>
                    <div className='samples'>
                        {toList(data.samples, undefined, (item, i) => <div className='sample'>
                            <img src={Icon} alt='icons' />
                            <div>
                                {!fullmode[i] && item.length > 150 ? item.substring(0, 150) + '...' : item}
                                {!fullmode[i] && item.length > 150 && <span onClick={() => { fullmode[i] = true; setFullmode([...fullmode]); }}>Read More</span>}
                            </div>
                        </div>)}
                    </div>
                </div>
            }
        </div>
    );
}

export default Samples;